import { render } from "./PreviousCanvas.vue?vue&type=template&id=e1cb0354&scoped=true"
import script from "./PreviousCanvas.vue?vue&type=script&lang=js"
export * from "./PreviousCanvas.vue?vue&type=script&lang=js"

import "./PreviousCanvas.vue?vue&type=style&index=0&id=e1cb0354&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1cb0354"]])

export default __exports__